// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CollapsibleBlock_titleContainer__bHHIw","editButtonContainer":"CollapsibleBlock_editButtonContainer__2mCim","title":"CollapsibleBlock_title__37LGy"};